import { render, staticRenderFns } from "./Intelligentmatching.vue?vue&type=template&id=e29bc9c8&scoped=true"
import script from "./Intelligentmatching.vue?vue&type=script&lang=js"
export * from "./Intelligentmatching.vue?vue&type=script&lang=js"
import style0 from "./Intelligentmatching.vue?vue&type=style&index=0&id=e29bc9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29bc9c8",
  null
  
)

export default component.exports